import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const CroppedImage = ({ img, newWidth, newHeight, startX, startY, containerWidth = 568, containerHeight = 118 }) => {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) { return }

    const ctx = canvas.getContext('2d')
    const image = new Image()

    image.onload = () => {
      canvas.width = containerWidth
      canvas.height = containerHeight
      ctx.drawImage(image, startX, startY, newWidth, newHeight, 0, 0, containerWidth, containerHeight)
    }

    image.src = img
  }, [ img, newWidth, newHeight, startX, startY ])

  return <canvas ref={canvasRef} />

}
CroppedImage.propTypes = {
  img: PropTypes.string.isRequired,
  newWidth: PropTypes.number.isRequired,
  newHeight: PropTypes.number.isRequired,
  startX: PropTypes.number.isRequired,
  startY: PropTypes.number.isRequired,
  containerWidth: PropTypes.number,
  containerHeight: PropTypes.number,
}

export default CroppedImage
